import style from './style.module.less';
import React from 'react';
import { Link } from 'react-router';
import { map, sortBy } from 'lodash';
import moment from 'moment';
import 'moment/locale/de';

function ListFilteredEvents({ events }) {
    const sortedEvents = sortBy(events, event => moment(event.data.date).format('X'));

    return (
        <ul className={style.eventList}>
            {map(sortedEvents, (event, idx) => {
                const d = moment(event.data.date);
                const formattedDate = d.format('ddd, DD.MM.YYYY HH:mm');

                return (
                    <li key={idx} className={style.event}>
                        <Link to={event.path}>
                            <div className={style.date}>
                                {formattedDate}
                            </div>
                            {event.data.title}

                            {event.data.title2 &&
                                <span>
                                    , {event.data.title2}
                                </span>}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
}

export default ListFilteredEvents;



// WEBPACK FOOTER //
// ../components/ListFilteredEvents/index.js